import { useState }          from 'react'
import { Button, TextField } from '../index'

export default function SettingsSingleElementForm( props: any ): JSX.Element {
  const { handleFormSubmit, item, namePlaceholder } = props
  const [ name, setName ]                           = useState( item?.name ?? '' )
  const [ nameError, setNameError ]                 = useState( false )

  const handleSubmit: any = (): any => {
    setNameError( false )

    if ( !name.length || name.length < 3 ) {
      setNameError( true )
      return
    }

    if ( item?.name === name ) return

    handleFormSubmit( name, item?.id ?? '' )
  }

  return (
    <div className="flex flex-col w-full bg-white rounded-3xl p-4 xl:p-5 space-y-4">
      <div className="flex items-center justify-between">
        <div className="flex flex-wrap items-center">
          <TextField
            label=""
            value={ name }
            name="name"
            type="text"
            onChange={ setName }
            placeholder={ item?.id ? '' : namePlaceholder ?? 'Type new item name ...' }
            wrapperClasses="w-full"
            fieldClasses={ `py-4 px-5 border ${ nameError ? 'border-red-600' : 'border-grey-light' } rounded-2xl w-full text-blue-input font-medium placeholder-grey-input` }
            isRequired
          />
        </div>
        <div className="flex flex-wrap items-center">
          <Button label={ item ? 'Update' : 'Create' } yellow onClick={ handleSubmit } />
        </div>
      </div>
    </div>
  )
}
